<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row
            dense
            no-gutters
            class="mb-5 text-center text-md-left subtitle-1"
          >
            <v-col cols="12" lg="2">
              Daily gross sales:
              <v-avatar :size="$gold_coin_sm"
                ><img :src="$goldCoinWhite" alt="coin"
              /></v-avatar>
              <strong>{{
                setsettings != 1 ? "TBP" : totalSales | toNumberWithDecimal
              }}</strong>
            </v-col>
          </v-row>

          <v-row dense class="d-flex justify-end mt-8">
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Player</span>
              <player-autocomplete-template
                ref="player_autocomplete"
                filtertype="bethistory"
              ></player-autocomplete-template>
            </v-col> -->


            <v-col cols="12" lg="2" class="span-label" :class="($hideifuserisSupervisor())">
              <span>{{ $agentName }}</span>
              <agent-credit-autocomplete-template
                ref="agent_autocomplete"
              ></agent-credit-autocomplete-template>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Player</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="playerlist"
                item-value="id"
                item-text="username"
                label="Player"
                v-model="filter.player_id"
              >
              </v-combobox>
            </v-col>

            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Player type</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="['GM', 'App']"
                label="Player type"
                v-model="filter.playerType"
              ></v-select>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Status</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="['Successful', 'Void']"
                label="Status"
                v-model="filter.status"
              ></v-select>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Draw</span>
              <v-select
                class="regular-field"
                dense
                clearable
                :items="drawlist"
                item-value="id"
                item-text="name"
                label="Draw"
                v-model="filter.draw"
                multiple
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption"
                    >(+{{ filter.draw.length - 1 }})</span
                  >
                </template>
              </v-select>
            </v-col>
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Region</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="region_list"
                item-value="id"
                item-text="region_name"
                label="Region"
                v-model="filter.region_id"
              >
              </v-combobox>
            </v-col> -->
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Area</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="arealist"
                item-value="id"
                item-text="name"
                label="Area"
                v-model="filter.zone_id"
              >
              </v-combobox>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Dates</span>
              <v-dialog
                ref="dialog"
                v-model="filter_datedialog"
                :return-value.sync="filter.daterange"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="regular-field"
                    hide-details
                    dense
                    v-model="filter.daterange"
                    label="Dates"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.daterange" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="red_button"
                    @click="filter_datedialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="green_button"
                    @click="$refs.dialog.save(filter.daterange)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col cols="12" lg="3" class="span-label">
              <span>Search any keyword</span>
              <v-text-field
                clearable
                class="regular-field"
                single-line
                v-model="dt_searchQuery"
                label="Search"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="custom_info"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.bet`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.bet | toNumberWithDecimal }}</template
                >

                <template v-slot:[`item.drawdate`]="{ item }">{{
                  item.drawdate | datetime
                }}</template>

                <template v-slot:[`item.user_id`]="{ item }">{{
                  item.user_id ? "App" : "GM"
                }}</template>

                <template v-slot:[`item.combination`]="{ item }">{{ item.combination }} {{ setIsRambol(item.combination, item.isramble, item.numberformat) }}</template>

                <template v-slot:[`item.winningprize`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.winningprize | toNumberWithDecimal }}</template
                >

                <template v-slot:[`item.status`]="{ item }">
                  <div v-if="canVoid(item)">
                    <v-btn-toggle block rounded>
                      <v-btn
                        color="error"
                        dark
                        small
                        :loading="isLoadingBtn"
                        @click="voidBet(item)"
                        >Void</v-btn
                      >
                    </v-btn-toggle>
                  </div>
                  <div v-else>{{ item.status }}</div>
                </template>

                <!-- <template v-slot:[`item.actions`] v-if="$role.restricAccess($route.name, 'edit')">
                                    <v-btn color="info" block outlined dark small>
                                        Edit
                                    </v-btn>
                                </template> -->
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <confirm-dialog ref="confirm"></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      setsettings: null,
      dt_headers: [
        {
          // text:
          //   this.$store.state.currentUser.agent_data.level == 1
          //     ? "Parent manager"
          //     : "Manager",
          text: this.$agentName,
          value: "full_name",
          name: "full_name",
          sortable: false,
          searchable: true,
        },
        {
          text: "Parent",
          value: "parent",
          name: "parent",
          sortable: false,
          searchable: true,
        },
        {
          text: "Player",
          value: "username",
          name: "p.username",
          sortable: false,
          searchable: true,
        },
        // {
        //   text: "Player type",
        //   value: "user_id",
        //   name: "p.user_id",
        //   sortable: false,
        //   searchable: true,
        // },
        {
          text: "Contact #",
          value: "contact_no",
          name: "contact_no",
          sortable: false,
          searchable: true,
        },

        {
          text: "Reference #",
          value: "referenceno",
          name: "referenceno",
          sortable: false,
          searchable: true,
        },
        {
          text: "Draw",
          value: "draw_name",
          name: "draw_name",
          sortable: false,
          searchable: false,
        },
        // {
        //   text: "Area",
        //   value: "zone_name",
        //   name: "zone_name",
        //   sortable: false,
        //   searchable: false,
        // },
        {
          text: "Combination",
          value: "combination",
          name: "combination",
          sortable: false,
          searchable: true,
        },
        {
          text: "Bet amount",
          value: "bet",
          name: "bet",
          sortable: false,
          searchable: true,
        },
        {
          text: "Payout",
          value: "winningprize",
          name: "winningprize",
          sortable: false,
          searchable: true,
        },
        {
          text: "Date/Time",
          value: "drawdate",
          name: "drawdate",
          sortable: false,
          searchable: false,
        },
        {
          text: "Status",
          value: "status",
          name: "status",
          sortable: false,
          searchable: false,
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      form: new this.$Form({
        id: "",
        name: "",
        username: "",
        email: "",
        password: "",
        roles: {},
        user_status: 1,
      }),
      agentID: new this.$Form({
        agent_id:
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null,
      }),
      filter: {
        datefrom: null,
        dateto: null,
        draw: [],
        daterange: [
          this.$moment().format("YYYY-MM-DD"),
          this.$moment().format("YYYY-MM-DD"),
        ],
        status: "Successful",
        playerType: null,
        zone_id: null,
        region_id: null,
        player_id: null,
      },
      filter_datedialog: null,
      region_list: [],
      drawlist: [],
      arealist: [],
      playerlist: [],
      totalSales: 0,
      excempted_subagents_to_void: [],
      is_can_void: 0,
    };
  },
  methods: {
    setIsRambol(combination, isrambol, numberformat){
      combination = combination.split("-");
      if(combination.length == 2){
        return (isrambol) ? isrambol:null;
      }else if(combination.length == 3 && numberformat == "0-9"){
        return (isrambol) ? isrambol:null;
      }
    },
    canVoid(data) {
      var users = this.excempted_subagents_to_void;
      var isMaster =
        this.$store.state.currentUser.agent_data.level == 0 ? true : false;
      var isUserCanVoid = false;

      if (isMaster) {
        isUserCanVoid = true;
      } else {
        if(users){
          if (users.includes(this.$store.state.currentUser.agent_data.id)) {
            isUserCanVoid = true;
          }
        }
      }

      if (this.is_can_void == 1) {
        isUserCanVoid = true;
      }

      if (isUserCanVoid && data.status != "Void") {
        return data.canVoid;
        // let current_time = this.$moment().valueOf();
        // let datetimeclose = this.$moment(data.datetimeclose).valueOf();
        // if (
        //   datetimeclose - current_time >= 0 &&
        //   datetimeclose - current_time >= 600000
        // ) {
        //   return true;
        // }
      }

      return false;
    },
    async voidBet(row) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ) {
        if (this.isLoadingBtn) return;
        this.isLoadingBtn = true;

        this.$axios
          .get(this.$_CONFIG.api("API_BET_VOID") + "/" + row.id)
          .then((data) => {
            this.isLoadingBtn = false;
            this.getDataFromApi();
          })
          .catch((error) => {
            this.isLoadingBtn = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      }
    },
    betdialogbox() {
      this.$router.push({ name: "bet_add" });
    },
    paramsfilter() {
      var from,
        to = "";

      if (this.filter.daterange) {
        from = this.$moment(this.filter.daterange[0]).format("YYYY-MM-DD");
        to = this.$moment(this.filter.daterange[1]).format("YYYY-MM-DD");
      }

      let player = null;
      try {
        if (this.filter.player_id) {
          player = this.filter.player_id["id"];
        }
      } catch (error) {
        player = null;
      }

      let subagent =
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null;
      try {
        if (this.$refs.agent_autocomplete.autocomplete_model.id) {
          subagent = this.$refs.agent_autocomplete.autocomplete_model.id;
        }
      } catch (error) {
        subagent =
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null;
      }

 

      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        reload: this.dt_reload,
        draw: this.filter.draw.join(","),
        from: from,
        to: to,
        status: this.filter.status,
        player: player,
        agent_id: subagent,
        playerType: this.filter.playerType,
        zone_id: this.filter.zone_id,
        region_id: this.filter.region_id,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = await this.$_CONFIG.api("API_BET_HISTORY");

      await this.$axios
        .get(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.totalSales = res.data.totalSales;
          this.excempted_subagents_to_void = res.data.alwd;
          this.is_can_void = res.data.is_void;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log("Error searching");
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    getdrawlist() {
      this.$axios
        .get(this.$_CONFIG.api("API_DRAW_DROPDOWN"))
        .then((res) => {
          this.drawlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getarealist() {
      this.$axios
        .get(this.$_CONFIG.api() + "/allzonelist")
        .then((res) => {
          this.arealist = res.data;
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getplayerlist() {
      this.agentID
        .post(this.$_CONFIG.api() + "/v1/playerlist")
        .then((res) => {
          this.playerlist = res.data;
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSettings() {
      this.$axios
        .get(this.$_CONFIG.api("API_SETTINGS"))
        .then((data) => {
          this.setsettings = data.data["publish"];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async regionlist() {
      let response = await this.$axios.get(
        this.$_CONFIG.api() + "/allregionlist"
      );
      this.region_list = response.data;
    },
  },
  created() {
    this.getdrawlist();
    this.getarealist();
    this.getDataFromApi();
    this.getSettings();
    this.regionlist();
    this.getplayerlist();
  },
  mounted() {
    // if(this.$vuetify.breakpoint.mobile){
    //     this.$toast.fire({ icon: 'success', title: "TEST", position: 'bottom', timer: 5000 });
    // }else{
    //     this.$toast.fire({ icon: 'success', title: "TEST", timer: 5000 });
    // }
  },
};
</script>
<style scoped></style>